
import React, { Component } from 'react';
import './contact-bulk-import.scss'
import { Modal, ModalBody } from "reactstrap";
import { ImageConstants, Constants } from '../../../constants/constants';
import { getImageSource } from '../../../utility/image-source'
import CommonUtils from '../../../utility/common-utilities';
import ExcelToJson from '../../common/excel-to-json/excel-to-json';
import SchoolUserApi from '../../../apis/student'
import SchoolApi from '../../../apis/school';

class StudentBulkImport extends Component {

    state = {
        classDetails: this.props.selectedClass
    }

    onSave() {
        this.setState({ isSubmit: true })

        if (!this.validatePayload(this.state.staffs)) return

        let payload = {
            staffs: this.state.staffs
        }

        this.setState({ isSaving: true })

        SchoolApi.addBulkStaffs(payload).then(response => {
            this.setState({ isSubmit: false, isSaving: false })

            if (response?.data?.duplicateEmails?.length) {
                let emails = response?.data?.duplicateEmails
                this.setState({ errorMessage: `Duplicate Records (please remove it): ${emails.join(", ")}` })
                return
            }
            this.props.onClose(true)
        }).catch(err => {
            this.setState({ isSubmit: false, isSaving: false })
        })

    }

    validatePayload(staffs = []) {

        if (!staffs.length) {
            this.setState({ errorMessage: "Please select valid staff" })
            return false
        }

        for (let i = 0; i < staffs.length; i++) {

            let payload = staffs[i]

            if (!payload.types) {
                this.setState({ errorMessage: `please enter type line no: ${i + 2}` })
                return false
            }

            if (!payload.gender) {
                this.setState({ errorMessage: `please enter gender line no: ${i + 2}` })
                return false
            }

            if (!payload.firstName) {
                this.setState({ errorMessage: `please enter first name line no: ${i + 2}` })
                return false
            }

            if (!payload.lastName) {
                this.setState({ errorMessage: `please enter last name line no: ${i + 2}` })
                return false
            }

            if (!this.validateEmail(payload.email) || !payload.email) {
                this.setState({ errorMessage: `please enter valid email line no: ${i + 2}` })
                return false
            }

            if (!payload.countryCode && payload.mobileNumber) {
                this.setState({ errorMessage: `please enter valid mobile number line no: ${i + 2}` })
                return false
            }
        }

        this.setState({ errorMessage: "" })
        return true
    }


    validateEmail(value) {
        if (value) {
            let isValid = CommonUtils.validateEmail(value);
            if (!isValid) {
                this.setState({ isInvalidEmail: true });
                return false
            }
            else {
                this.setState({ isInvalidEmail: false })
                return true
            }
        } else {
            this.setState({ isInvalidEmail: true });
            return false
        }
    }


    onSuccessUploadExcel = (res) => {

        if (res.data) {

            let staffs = this.extractFromExcel(res?.data)
            this.setState({
                excelFileName: res?.fileName || "",
                staffs
            })
            return
        }

        if (res.error) {
            this.setState({ errorMessage: "Excel upload error" })
        }
    }

    extractFromExcel(data) {
        let studentsList = []

        for (let i = 0; i < data.length; i++) {
            let obj = data[i]
            let student = {
                firstName: obj["First Name"],
                lastName: obj["Last Name"],
                gender: obj["Gender"],
                types: obj["Types"] ? obj["Types"].split(" ").join("_") : "",
                email: obj["Email"],
                countryCode: obj["Country Code"],
                mobileNumber: obj["Mobile Number"],
                landline: obj["Landline"],
            }
            studentsList.push(student)
        }

        return studentsList
    }

    removeExcelFile() {
        this.setState({ excelFileName: "", staffs: [] })
    }


    showExcelFormat = () => {
        const link = document.createElement('a');
        link.href = Constants.STAFF_EXCEL_FORMAT
        link.target = '_blank';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }

    render() {
        return (
            <Modal className="cw-custom-modal" isOpen={true} toggle={this.props.onClose} size={this.props.size || 'md'}>

                <ModalBody >

                    <div className="row">
                        <div className="col">
                            <img className="close-icon cursor-pointer" onClick={this.props.onClose} src={getImageSource(ImageConstants.CROSS)} />
                        </div>
                    </div>

                    <div className="contact-bulk-import">

                        <div className="header-text text-center">
                            <span>{this.props.title || "ADD A CONTACT"}</span>
                        </div>

                        <div className='bw-spaces-input py-5'>
                            <div className="import-excel-div ">
                                <label className="py-2 px-4 m-0">
                                    {this.state?.excelFileName || ""}
                                </label>
                                {
                                    this.state.excelFileName ?
                                        <label className="excel float-right text-danger py-2 px-4 m-0" onClick={() => this.removeExcelFile()}>
                                            REMOVE EXCEL
                                        </label> :
                                        <label className="excel float-right text-success py-2 px-4 m-0">
                                            <ExcelToJson onSuccess={this.onSuccessUploadExcel} />
                                            ADD EXCEL
                                        </label>}
                            </div>
                            <div className="text-right pt-1">
                                <span className='check-text' onClick={this.showExcelFormat}>
                                    <img alt=""
                                        className='export-xls'
                                        src={getImageSource(ImageConstants.XLS_BLUE)}
                                    />
                                    Check Format Here
                                </span>
                            </div>
                        </div>

                        <div className="text-center">
                            {this.state.errorMessage ? <div className="text-danger pb-4"><strong>{this.state.errorMessage} </strong></div> : ""}
                            <button className="cw-button-primary" onClick={() => this.onSave()}>
                                Save
                            </button>
                        </div>
                    </div>
                </ModalBody>

            </Modal >
        );
    }
}

export default StudentBulkImport;